export default function HeaderMegaMenu() {
  const megaMenuContainer = document.querySelector<HTMLElement>(".js-mega-menu-container");
  const hideOnScroll = megaMenuContainer?.getAttribute("data-hide-on-scroll")?.toLowerCase() === "true";
  const menu = document.querySelector<HTMLElement>(".js-desktop-header-menu");
  const items = menu?.querySelectorAll<HTMLDivElement>(".js-menu-item");
  const stickySidebarNav: HTMLDivElement | null = document.querySelector(".js-sticky-sidebar-nav");

  if (items && items.length > 0) {
    items.forEach((item) => {
      const megaMenu = item.querySelector<HTMLDivElement>(".js-mega-menu-item");
      const level2items = item.querySelectorAll<HTMLAnchorElement>("[data-list-id]");
      const level3lists = item.querySelectorAll<HTMLUListElement>("[data-list]");

      if (megaMenu) {
        const links = megaMenu.querySelectorAll<HTMLAnchorElement>("a, button");

        const resetTabIndexes = () => {
          links.forEach((link) => {
            link.setAttribute("tabindex", "-1");
          });
          handleIsActive(0);
        };

        const setTabIndexes = (isVisible: boolean) => {
          links.forEach((link) => {
            if (isVisible) {
              link.setAttribute("tabindex", "0");
            } else {
              link.setAttribute("tabindex", "-1");
            }
          });
        };

        const handleResetLevelTwo = () => {
          level2items.forEach((item) => {
            item.setAttribute("data-active", "false");
          });
        };

        const handleResetLevelThree = () => {
          level3lists.forEach((list) => {
            list.setAttribute("data-active", "false");
          });
        };

        const handleIsActive = (index: number) => {
          if (level2items[index]) {
            handleResetLevelTwo();
            handleResetLevelThree();
            level2items[index].setAttribute("data-active", "true");
          }

          if (level3lists[index]) {
            handleResetLevelThree();
            level3lists[index].setAttribute("data-active", "true");
          }
        };

        const handleLevel2Keydown = (e: KeyboardEvent, index: number) => {
          // if someone hits tab from level 2
          if (e.key === "Tab") {
            if (e.shiftKey) {
              if (index !== 0) {
                e.preventDefault();
                // set active level 2 item if someone hits shift/tab and it's not the first item in the list
                handleIsActive(index - 1);
                level2items[index - 1].focus();
              }
            } else {
              // check if there are level 3 child items
              if (handleHasLevelThreeItems(index)) {
                e.preventDefault();
                // set focus to level 3
                handleIsActive(index);
                handleFocusLevelThree(e, index);
              } else {
                // set next level 2 item to active if there are not level 3 items
                if (level2items[index + 1]) {
                  handleIsActive(index + 1);
                } else {
                  // if there isn't a level 3 item and there isn't a next level 2 item then the menu closes and active index is reset
                  resetTabIndexes();
                }
              }
            }
          }
        };

        const handleFocusParentLevel = (e: KeyboardEvent, index: number) => {
          if (e.key === "Tab" && e.shiftKey) {
            e.preventDefault();
            level2items[index].focus();
          }
        };

        const handleFocusNextLevel = (index: number) => {
          const activeIndex = index + 1;
          if (level2items[activeIndex]) {
            handleIsActive(activeIndex);
            level2items[activeIndex].focus();
          } else {
            // if there isn't a next level then the menu closes and resets the active index to 0
            resetTabIndexes();
            //   link.addEventListener("focusout", resetTabIndexes);
          }
        };

        const handleHasLevelThreeItems = (index: number) => {
          if (level3lists[index]) {
            const links = level3lists[index].querySelectorAll<HTMLAnchorElement>("a, button");

            if (links && links.length > 0) {
              return true;
            } else {
              return false;
            }
          } else {
            return false;
          }
        };

        const handleFocusLevelThree = (e: KeyboardEvent, index: number) => {
          if (level3lists[index]) {
            const links = level3lists[index].querySelectorAll<HTMLAnchorElement>("a, button");

            if (links && links.length > 0) {
              links.forEach((item, i) => {
                if (i === 0) {
                  e.preventDefault();
                  item.focus();
                }
              });
            }
          }
        };


        // primary nav event listeners
        item.addEventListener("mouseenter", () => setTabIndexes(true));
        item.addEventListener("mouseleave", () => setTabIndexes(false));
        item.addEventListener("focusin", () => setTabIndexes(true));

        // left column mega menu event listeners
        level2items.forEach((item, index) => {
          item.addEventListener("mouseenter", () => handleIsActive(index));
          item.addEventListener("keydown", (e: KeyboardEvent) => handleLevel2Keydown(e, index));
        });
        // right column link event listeners
        level3lists.forEach((list, index) => {
          const links = list.querySelectorAll<HTMLAnchorElement>("a, button");

          links.forEach((item, i) => {
            if (i === 0) {
              item.addEventListener("keydown", (e: KeyboardEvent) => handleFocusParentLevel(e, index));
            }

            if (i === links.length - 1) {
              item.addEventListener("focusout", () => handleFocusNextLevel(index));
            }
          });
        });
      }
    });
  }
  
  if (hideOnScroll && megaMenuContainer) {
    let lastScrollY = window.scrollY;
    let isResizing = false;
    let resizeTimeout: number;
    let isLoaded = false;
    let megaMenuHeight = megaMenuContainer.offsetHeight;

    
    if (stickySidebarNav) {
      const header = document.querySelector('header');
      let isSticky = false;
      let rafId: number | null = null;
      
      const checkSticky = () => {
        if (!header || !stickySidebarNav) return;
        
        const scrollY = window.scrollY;
        const offsetTop = stickySidebarNav.offsetTop;
        const computedTop = parseInt(getComputedStyle(stickySidebarNav).top) || 0;
        
        // Element is sticky when scroll has passed its natural position
        const shouldBeSticky = scrollY >= (offsetTop - computedTop);
        
        if (shouldBeSticky !== isSticky) {
          isSticky = shouldBeSticky;
          stickySidebarNav.classList.toggle('isSticky', shouldBeSticky);
        }
      };
      
      //Limits scroll events
      window.addEventListener('scroll', () => {
        if (rafId) cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(checkSticky);
      }, { passive: true });
      
      window.addEventListener('resize', checkSticky);
      
      // Initial check after a short delay to ensure layout is complete
      setTimeout(checkSticky, 100);
    }
    // Ensure menu starts visible
    megaMenuContainer.style.transform = 'translateY(0)';
    
    if (stickySidebarNav) {
      stickySidebarNav.style.transition = 'transform 0.3s ease-out';
    }
  
    // Track window resize to ignore scroll events during resize
    window.addEventListener("resize", () => {
      isResizing = true;
      clearTimeout(resizeTimeout);
      
      resizeTimeout = window.setTimeout(() => {
        isResizing = false;
        lastScrollY = window.scrollY;
        // Recalculate mega menu height after resize
        megaMenuHeight = megaMenuContainer.offsetHeight;
        
        // Trigger a custom event to notify sticky-sidebar-nav to recalculate
        // This ensures it recalculates after mega menu height changes
        window.dispatchEvent(new CustomEvent('headerResize'));
      }, 200);
    });
  
    window.addEventListener("scroll", () => {
      // Ignore scroll events during resize or before page load
      if (isResizing || !isLoaded) return;
      const isDesktop = window.matchMedia('(min-width: 768px)');
      let isDesktopView = isDesktop.matches;

      const currentScrollY = window.scrollY;
      if (currentScrollY > lastScrollY) {
        // User is scrolling down
        megaMenuContainer.setAttribute('inert', 'true')
        megaMenuContainer.style.transform = 'translateY(-100%)';
        
        if (stickySidebarNav && stickySidebarNav?.classList.contains('isSticky') && isDesktopView) {
          stickySidebarNav?.style.setProperty("transform", `translateY(-${megaMenuHeight}px)`);
        }
      } else if (currentScrollY < lastScrollY) {
        // User is scrolling up
        megaMenuContainer.style.transform = 'translateY(0)';
        megaMenuContainer.removeAttribute('inert')

        if(stickySidebarNav) stickySidebarNav?.style.setProperty("transform", "translateY(0)");
      }
      lastScrollY = currentScrollY;
    });
  
    window.addEventListener('load', () => {
      isLoaded = true;
      lastScrollY = window.scrollY;
    })
  }
}
